module.exports = `${require.publicPath}home-bg1.88a787e5.png`;